var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-subtitle-2 font-weight-bold light-blue--text text--darken-4"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"text-body-2 grey--text text--darken-4"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }